import React, { useState, useEffect } from "react";
import { FaPlus, FaMinus, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartItems, updateCartItem, removeCartItem } from "../../features/userfeatures/cart/cartUserSilce";
import "./CartComponent.css";
import Navbar from "../Navbar";
import Footer from "../layouts/Footer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Cart = () => {
  
 const dispatch = useDispatch();
  const { loading, cartItems, error } = useSelector((state) => state.cartUser);
//   console.log('asdf:', cartItems)

  // Fetch cart items on component mount
  useEffect(() => {
    // Fetch only if cartItems is empty
    if (cartItems.length === 0) {
      dispatch(fetchCartItems());
    }
  }, [dispatch, cartItems.length]);

  const [timer, setTimer] = useState(60 * 38 + 23); // Countdown timer in seconds (38:23)

//   const cartLength = cartItems.length;


  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const handleQuantityChange = async (item, action) => {
    const updates = { action };

    try {
      dispatch(updateCartItem({ id: item._id, updates }));
    } catch (error) {
      // Display toast for error messages
      toast.error(error.message || "An error occurred while updating quantity");
    }
  };


  const handleRemoveItem = (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      dispatch(removeCartItem(id));
    }
  };

  if (loading) {
    return <p>Loading...</p>; // Loading state
  }

  if (error) {
    return <p>Error: {error}</p>; // Error handling
  }

  return (
    <>
      <Navbar />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <div className="container my-5">
        <h2>Your Cart</h2>
        {cartItems.length === 0 ? (
          <div className="alert alert-info">
            Your cart is empty. Add items to start shopping!
          </div>
        ) : (
          <>
            {" "}
            <div className="alert alert-warning">
              <i className="bi bi-info-circle"></i>
              Please, hurry! Someone has placed an order on one of the items you
              have in the cart. We'll keep it for you for{" "}
              <strong>{formatTime(timer)}</strong> minutes.
            </div>
            <table className="table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map((item) => (
                  <tr key={item._id}>
                    <td>
                      <img src={item.image} alt={item.name} width="50" />
                      <div>
                        <strong>
                          {item.product_id.tite || "Office Registers"}
                        </strong>
                        <p>
                          {item.product_id.descriptio ||
                            "Office register  for record maintenance"}
                        </p>
                        {/* <p>{item.product_id.brand}</p> */}
                      </div>
                    </td>
                    <td>Rs. {item.product_id.price} </td>
                    <td>
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => handleQuantityChange(item, "minus")}
                      >
                        <FaMinus />
                      </button>
                      <span className="mx-2">{item.quantity}</span>
                      <button
                        className="btn btn-sm btn-light"
                        onClick={() => handleQuantityChange(item, "plus")}
                      >
                        <FaPlus />
                      </button>
                    </td>
                    <td>Rs. {item.product_id.price * item.quantity}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleRemoveItem(item._id)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="form-group">
              <label htmlFor="additionalComments">Additional Comments</label>
              <textarea
                id="additionalComments"
                className="form-control"
                placeholder="Special instruction for seller..."
              ></textarea>
            </div>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Cart;
